<mat-form-field appearance="outline">
  <mat-label>{{ label() }}</mat-label>
  <input
    matInput
    type="text"
    [formControl]="autocompleteControl"
    [matAutocomplete]="sourceAutocomplete"
    #trigger="matAutocompleteTrigger"
  />
  @if (autocompleteControl.value && !autocompleteControl.disabled) {
    <button (click)="clear($event)" class="clear-field" mat-icon-button matSuffix>
      <mat-icon>close</mat-icon>
    </button>
  }
  <mat-autocomplete
    [hideSingleSelectionIndicator]="true"
    [autoActiveFirstOption]="true"
    #sourceAutocomplete="matAutocomplete"
    [displayWith]="displayOption"
    (opened)="onAutocompleteOpened(trigger)"
    (closed)="onAutocompleteClosed()"
  >
    @for (option of filteredOptions$ | async; track trackById($index, option)) {
      <mat-option [value]="option">
        <div class="option">
          @if (!option.enabled) {
            <mat-icon class="option-warning" color="warn" matTooltip="This source is disabled">error</mat-icon>
          }
          <span>[{{ option?.pair?.name }}] {{ option.name }}</span>
        </div>
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
